import  {useEffect} from 'react';
import {useNavigate} from "react-router";
import {useAuth} from "../context/authContext";
import {LogoutService} from "../services/employee";

const Logout = () => {
    const navigate = useNavigate();
    const { setEmp,employeeI } = useAuth();
    const logout = async () => {
        try {
            // console.log("Hello")
            await LogoutService()
            // console.log(result.data)
            setEmp(undefined);

        }catch(err) {
            console.error(err)
        }
    }
    useEffect(() => {
        // localStorage.removeItem("token");
        if (!employeeI){
            navigate("/", { replace: true });
            return;
        }

        logout().then();
        // navigate("/", { replace: true });
        setTimeout(() => {
            navigate("/", { replace: true });
        }, 250);
    }, [employeeI]);
    return null;
};

export default Logout;